<template>
    <footer class="mt-5">

        <div class="container">
            <div class="d-flex flex-column flex-xl-row justify-content-between align-items-center align-items-md-start">

                <div class="d-flex flex-column flex-md-row justify-content-between justify-content-lg-around w-lg-50 pt-2">
                    <div class="text-center pt-1">
                        <img src="../../assets/imgs/general/logo_academie.png" alt="" class="img-fluid">

                        <!--<h6 class="pt-4">Urmărește-ne pe</h6>-->
                        <div class="d-flex flex-row justify-content-center pt-3 pt-lg-4">
                            <a href="https://www.facebook.com/DrLeahuCliniciDentare/" target="_blank" class="px-3">
                                <img src="../../assets/imgs/footer/facebook.png" alt="" class="img-fluid">
                            </a>
                            <a href="https://www.instagram.com/drleahudentalclinics/" target="_blank" class="px-3">
                                <img src="../../assets/imgs/footer/instagram.png" alt="" class="img-fluid">
                            </a>
                        </div>
                    </div>

                    <div id="page-links"
                         class="d-flex flex-column align-items-center align-items-md-start pt-4 pt-md-0">
                        <a id="leahu_academy_footer"><h6 class="pt-2">Academia Spațială</h6></a>
                        <a href="#tuti_world"><h6 class="pt-2">Lumea lui Tuti</h6></a>
                        <a href="#games"><h6 class="pt-2">Antrenamente spațiale</h6></a>
                        <a href="#yummy"><h6 class="pt-2">Yummy Galaxy</h6></a>
                        <a href="#contact"><h6 class="pt-2">Contact</h6></a>
                        <button data-toggle="modal" data-target="#credits-modal" id="toggleCreditsModal" class="px-0">
                            <h6 class="pt-2">Credits</h6>
                        </button>
                    </div>
                </div>

                <div class="d-flex flex-column flex-md-row justify-content-between justify-content-lg-around w-lg-50 pt-4 pt-xl-2">

                    <div class="order-2 order-lg-1 text-center">
                        <div class="gmap_canvas pt-4 pt-md-0">
                            <iframe frameborder="0"
                                    height="200"
                                    width="290"
                                    id="gmap_canvas"
                                    marginheight="0"
                                    marginwidth="0"
                                    scrolling="no"
                                    src="https://maps.google.com/maps?q=Strada%20Louis%20Blanc%2019%2CBucharest&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            ></iframe>
                        </div>
                    </div>

                    <div class="d-flex flex-column align-items-center align-items-md-start pt-4 pt-md-0 order-1 order-lg-2"
                         id="contact">
                        <h6>Informații de contact</h6>
                        <div class="d-flex flex-row pt-1">
                            <a href="tel:021 9134">
                                <img src="../../assets/imgs/footer/phone.png" alt="" class="img-fluid">
                                <span class="pl-2 my-auto">021 9134</span>
                            </a>
                        </div>
                        <div class="d-flex flex-row pt-1">
                            <a href="mailto:programari@drleahu.ro">
                                <img src="../../assets/imgs/footer/email.png" alt="" class="img-fluid">
                                <span class="pl-2 my-auto">programari@drleahu.ro</span>
                            </a>
                        </div>
                        <div class="d-flex flex-row pt-1">
                            <div><img src="../../assets/imgs/footer/program.png" alt="" class="img-fluid"></div>
                            <span class="pl-2">
                            Luni-Vineri: 09:00 - 21:00
<!--                                <br>-->
<!--                            Sâmbătă: 09:00 - 16:00-->
                        </span>
                        </div>
                        <div class="d-flex flex-row pt-1">
                            <div>
                                <img src="../../assets/imgs/footer/adresa.png" alt="" class="img-fluid">
                            </div>
                            <span class="pl-2 my-auto">Strada Louis Blanc 19</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <credits-modal></credits-modal>

        <hr>

        <div class="container">
            <div class="d-flex flex-column flex-lg-row justify-content-between pt-2 copyright pb-4 pb-md-0">
                <div class="order-2 order-lg-1 d-flex flex-column align-items-center align-items-lg-start">
                    <p>Copyright © Clinicile Dr.Leahu</p>
                </div>
                <div class="d-flex flex-column flex-lg-row  align-items-center  align-items-lg-start order-1 order-lg-2 ">
                    <a href="../../docs/nota_asdl.pdf" target="_blank">
                        <span>GDPR ASDL</span>
                    </a>
                    <span class="px-2 d-none d-lg-block"> | </span>
                    <a href="../../docs/nota_yummy.pdf" target="_blank">
                        <span>GDPR Yummy</span>
                    </a>
                    <span class="px-2 d-none d-lg-block"> | </span>
                    <a href="../../docs/termeni_si_conditii.pdf" target="_blank">
                        <span>Termeni şi condiţii</span>
                    </a>
                    <span class="px-2 d-none d-lg-block"> | </span>
                    <a href="../../docs/politica_de_confidentialitate.pdf" target="_blank">
                        <span>Politică de confidențialitate</span>
                    </a>
                    <span class="px-2 d-none d-lg-block"> | </span>
                    <a href="../../docs/politica_de_cookies.pdf" target="_blank">
                        <span>Politică de cookie-uri</span>
                    </a>
                    <span class="px-2 d-none d-lg-block"> | </span>
                    <a href="../../docs/tutorial.pdf" target="_blank">
                        <span>How To</span>
                    </a>
                </div>
            </div>
        </div>


    </footer>
</template>

<script>

    import CreditsModal from './CreditsModal'

    export default {
        name: "Footer",
        components: {CreditsModal},
        mounted() {
            const $ = window.$;

            $('#leahu_academy_footer').on('click', function () {

                const y = $('#leahu_academy').offset().top;
                window.scroll({
                    top: y - 100,
                    behavior: 'smooth'
                });

            });
        }
    }
</script>

<style lang="scss">
    @import '../../styles/footer.scss';
</style>
